var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-wrapper"},[_c('design-2021-help-zoho-tutorials-component'),_vm._v(" "),_c('div',{staticClass:"help-body"},[_c('div',{staticClass:"contact-form-and-info"},[_c('design-2021-help-contact-form-component',{attrs:{"user-in":_vm.userIn}}),_vm._v(" "),_c('design-2021-help-contact-info-component')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }